import { RouteGuard } from 'Src/ng2/routing/guards/route-guard/route-guard';
import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';
export const homeRoute = {
  path: 'home',
  url: '/home',
  canActivateChild: [RouteGuard],
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('./home.module').then(m => m.HomeModule),
};
